export function CommentIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2 4.00033C2 3.26395 2.59695 2.66699 3.33333 2.66699H12.6667C13.403 2.66699 14 3.26395 14 4.00033V9.33366C14 10.07 13.403 10.667 12.6667 10.667H10.6667L8 13.3337L5.33333 10.667H3.33333C2.59695 10.667 2 10.07 2 9.33366V4.00033Z'
        fill='white'
      />
      <path
        d='M4.66667 5.33366H11.3333M4.66667 8.00033H7.33333M8 13.3337L5.33333 10.667H3.33333C2.59695 10.667 2 10.07 2 9.33366V4.00033C2 3.26395 2.59695 2.66699 3.33333 2.66699H12.6667C13.403 2.66699 14 3.26395 14 4.00033V9.33366C14 10.07 13.403 10.667 12.6667 10.667H10.6667L8 13.3337Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
